import React, { HTMLAttributeAnchorTarget }  from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Link from "../../components/html/link";
import { greeting } from "../../portfolio";
import { Fade } from "react-awesome-reveal";
import FeelingProud from "./FeelingProud";
import {ThemeProps} from "../../components/styles/themeprops";
import { useTranslation } from "react-i18next";

type GreetingProps = {
  children?: React.ReactNode;
  theme:ThemeProps
};

export default function Greeting({
  children,
  theme,
}: GreetingProps) {
  const themeVar = {theme};
  const { t, i18n } = useTranslation();
  return (
    <Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: themeVar.theme.text }}>
                {greeting.title}
              </h1>
              {greeting.nickname && (
                <h2 className="greeting-nickname" style={{ color: themeVar.theme.text }}>
                  ( {greeting.nickname} )
                </h2>
              )}
              <p
                className="greeting-text-p subTitle"
                style={{ color: theme.secondaryText }}
              >
                {t(greeting.subTitle)}
              </p>
              <p className="greeting-text-p subTitle">
              	{t("blog")}
              	</p>
              	<ul>
              		<li><a href="http://pariyani.blogspot.com">Blog</a></li>
              		<li><a href="http://blog.pariyani.com">Blog</a></li>
              	</ul>
              <SocialMedia theme={theme} />
              <div className="portfolio-repo-btn-div">
                <Link
                  text="⭐ Star Me On Github"
                  target="_blank"
                  href={greeting.portfolio_repository}
                  className="portfolio-repo-btn"
                />
              </div>
              {/* <div className="button-greeting-div">
              <Button text="Contact me" href="#contact" />
              <Button text="See my resume" newTab={true} href={greeting.resumeLink} />
            </div> */}
            </div>
          </div>
          <div className="greeting-image-div">
            {/* <img
							alt="saad sitting on table"
							src={require("../../assests/images/feelingProud.svg")}
						></img> */}
            <FeelingProud theme={themeVar.theme} />
          </div>
        </div>
      </div>
    </Fade>
  );
}
